<template>
  <section>
    <v-table
      url="/api/v1/moderator"
      :filter="filter"
      :appends="['dialogInModeration']"
      :attributes="[
        {
          name: 'Moderator',
          type: 'UserNoEmailCell',
          attribute: 'user',
          sortable: false
        },
        {
          attribute: 'customer',
          name: 'Mitglied',
          type: customerCell,
          sortable: false
        },
        {
          attribute: 'fake',
          name: 'Fake',
          type: 'LinkProfileCell',
          sortable: false
        },
        {
          attribute: 'dialogInModeration.dialog_id',
          name: 'Dialog',
          type: 'DialogInfoCell',
          sortable: false
        },
        {
          attribute: 'dialogInModeration.updated_at',
          name: 'Gesprächsdauer',
          type: 'TimeCounterCell',
          sortable: false
        },
        {
          attribute: 'dialogInModeration.last_message_at',
          name: 'Wartezeit Mitglied',
          type: 'TimeCounterCell',
          sortable: false
        },
        {
          attribute: 'recentMessages',
          name: 'Leistung',
          type: 'ModeratorEfficencyCell',
          sortable: false
        },
        {
          name: 'Aktionen',
          type: 'ModeratorInformationActionCell',
          sortable: false
        }
      ]"
      ref="modOnlineTable"
      @table-fetched="tableFetched"
    >
      <div slot="title">
        Moderatoren Information
      </div>
    </v-table>
  </section>
</template>

<script lang="babel">
export default {
  data() {
    return {
      fetchInterval: null,
      canFetch: true,
    }
  },
  mounted() {
    this.$bus.$on('waiting-dialogs-update', () => this.fetch());
    this.fetchInterval = setInterval(() => {
      this.fetch();
    }, 3500);
    this.fetch();
  },
  beforeDestory() {
    clearInterval(this.fetchInterval);
  },
  methods: {
    fetch() {
      if (this.canFetch && this.$refs.modOnlineTable) {
        this.canFetch = false;
        this.$refs.modOnlineTable.fetch().finally(() => this.canFetch = true);
      }
    },
    tableFetched() {
      let asaOnly = 0;
      this.$refs.modOnlineTable.models.forEach(function(model) {
        if (model.asa_only) {
          asaOnly++;
        }
      });
      this.$emit("count-update", this.$refs.modOnlineTable.count + " | " + asaOnly);
    }
  },
  computed: {
    filter() {
      let filter = [
        {
          name: 'inModeration',
        },
      ];
      if (Laravel.user.roles.some(el => el.name === "agency_leader")){
        filter.push({
            name: 'whereAgency',
            value: Laravel.user.moderator_profile.agency_id
        });
      }
      return filter;
    },
    customerCell() {
       return Laravel.user.roles.some(el => el.name === "agency_leader") ?
          'CustomerCell' : 'LinkProfileCell';
    }
  },
};
</script>
